import { Avatar, Checkbox, MenuItem, Select, Typography } from '@mui/material';
import React, { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ITicketShareUser } from 'store/ticket-share-service/types';

import {
	GeneralStepConversationTopics,
	NamespacesList,
	SharePermissions,
	TicketStages,
} from 'core/enums/common';

import * as Styled from 'components/TicketShare/UserCard/styled';

import { ISharePermissionEdit } from '../CreateTicketShareModal';
import { permissionsInfo } from '../CreateTicketShareModal/data';

interface IUserCardProps {
	ticketShareData: ITicketShareUser;
	isSelected: boolean;
	handleShareSelect: (shareId: string) => void;
	handlePermissionUpdate: (permission: ISharePermissionEdit) => void;
}

export const UserCard: FC<IUserCardProps> = ({
	ticketShareData,
	isSelected,
	handleShareSelect,
	handlePermissionUpdate,
}) => {
	const { t: commonTranslate } = useTranslation(NamespacesList['common']);

	const [sharePermission, setSharePermission] = useState(ticketShareData.permission);

	const user = useMemo(() => ticketShareData.userDto, [ticketShareData]);

	const handlePermissionChange = (value: SharePermissions | string) => {
		setSharePermission(Number(value));

		handlePermissionUpdate({ permission: Number(value), shareId: ticketShareData.id });
	};

	return (
		<Styled.ModalUser key={`${user.firstName} ${user.lastName}`}>
			<Styled.Owner sx={{ width: '45%' }}>
				<Avatar sx={{ bgcolor: '#1976d2' }} src={user?.avatarLink || ''}>
					{!user?.avatarLink && `${user?.firstName[0]}${user?.lastName[0]}`}
				</Avatar>
				<Styled.OwnerInfo>
					<Typography variant="h4">
						{user?.firstName} {user?.lastName}
					</Typography>
					<Typography>{user?.email}</Typography>
				</Styled.OwnerInfo>
			</Styled.Owner>
			<Select
				sx={{
					width: '22.5%',
					'& .MuiOutlinedInput-notchedOutline': {
						border: 'none',
					},
				}}
				value={sharePermission}
				onChange={(event) => handlePermissionChange(event.target.value)}
			>
				{permissionsInfo.map((permission, permissionIndex) => (
					<MenuItem
						key={`${permissionIndex}.${permission.label}`}
						value={permission.permissionEnum}
					>
						{commonTranslate(`accessLevels.${String(permission.label).toLowerCase()}`)}
					</MenuItem>
				))}
			</Select>
			<Styled.AccessData sx={{ width: '27.5%' }}>
				{ticketShareData.ticketCurrentStep !== null
					? ticketShareData.ticketCurrentStep === TicketStages.general &&
					  ticketShareData.subStageEnum !== null
						? commonTranslate(
								`modelsInput.${GeneralStepConversationTopics[ticketShareData.subStageEnum]}`
						  )
						: commonTranslate(`stepper.${TicketStages[ticketShareData.ticketCurrentStep]}Step`)
					: commonTranslate('text.all')}
			</Styled.AccessData>
			<Checkbox
				checked={isSelected}
				value={ticketShareData.id}
				onChange={(event) => handleShareSelect(event.target.value)}
			/>
		</Styled.ModalUser>
	);
};
